
<table class="table borderless" style="width: 100%;" width="100%">
    <tbody>
    <tr>
        <th style="text-align: left;"><b>Document Type</b></th>
        <th style="text-align: left;"><b>File Name</b></th>
        <th style="text-align: left;" class="cl-wdt"><b>Uploaded On</b></th>
        <th style="text-align: left;"><b>View&nbsp;File</b></th>
    </tr>
    <ng-container *ngIf="uploadedDocs">
        <tr class="text-primary" *ngFor="let doc of uploadedDocs">
            <td style="text-align: left;">{{doc.docType ? doc.docType : doc.description}}</td>
            <td style="text-align: left;">{{doc.desc ? doc.desc : doc.file_name}}</td>
            <td style="text-align: left;">{{(doc.uploadedOn ? doc.uploadedOn : doc.date_created)|date : 'dd/MM/yyyy'}}</td>
            <td style="text-align: center;">
                    <span title="View Document " class="btn btn-sm">
                      <img src="../../../assets/newimg/visibility-16@2x.png" (click)="viewDoc(doc)"/>
                      </span>
            </td>
        </tr>
        <tr *ngIf=" uploadedDocs.length==0">
            <td colspan="4" style="text-align:center">(No documents)</td>
        </tr>
    </ng-container>
    </tbody>
</table>
<button id="btnView" class="btn btn-primary" style="width: 0px; visibility:hidden;" aria-hidden="true" data-toggle="modal" data-target="#exampleModalLong"></button>
<div class="modal fade" id="exampleModalLong" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle"
     aria-hidden="true">
    <div class="modal-dialog modal-lg" style="min-height: 500px !important;" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">Document Uploaded</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body modal-lg">
                <img *ngIf="isPDF==2" [src]="doc" width="780" />
                <pdf-viewer *ngIf="isPDF==1" [src]="doc" [render-text]="true" style="display: block;" [original-size]="false"
                            [autoresize]="true"></pdf-viewer>
                <ngx-loading [show]="isLoadingImg"></ngx-loading>
            </div>
            <div class="modal-footer float-right" style="min-height: 25px !important;">
                <button type="button" class="btn btn-md m-clr hd-btn mr-2 mt-2"  data-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>
